import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  ListItemButton,
  ListItemText,
  Typography,
  Tooltip,
} from '@mui/material';
import { createNewDate, culture, options, addZero } from '../../Helpers/dates';

const NotificationBox = function NotificationBox({
  entityId = null,
  createdOn = null,
  sender = null,
  baseEntityFullName = null,
  content = null,
  title = null,
  onClick,
}) {
  const intl = useIntl();

  return (
    <Tooltip title={title} arrow placement="left">
      <ListItemButton
        onClick={(event) => {
          event.preventDefault();
          if (onClick) onClick(entityId, baseEntityFullName);
        }}
        divider
      >
        <ListItemText
          disableTypography
          primary={
            <Typography variant="body1">
              {`${baseEntityFullName} - ${sender || intl.messages.PHONE_NUMBER_UNAVAILABLE}`}
            </Typography>
          }
          secondary={
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {createdOn && (
                <Typography variant="overline">
                  {`${createNewDate(createdOn).toLocaleDateString(
                    culture,
                    options
                  )} - ${addZero(createNewDate(createdOn))}`}
                </Typography>
              )}
              <Typography variant="subtitle2">
                {content || intl.messages.NEW_MESSAGE}
              </Typography>
            </div>
          }
        />
      </ListItemButton>
    </Tooltip>
  );
};

NotificationBox.propTypes = {
  entityId: PropTypes.string,
  createdOn: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  sender: PropTypes.string,
  baseEntityFullName: PropTypes.string,
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default NotificationBox;
